import { render, staticRenderFns } from "./SchoolEmailPhone.vue?vue&type=template&id=44d8aa70&"
import script from "./SchoolEmailPhone.vue?vue&type=script&lang=js&"
export * from "./SchoolEmailPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports